import { clsx } from "clsx";
import type { ReactNode } from "react";

import styles from "./trax-card.module.css";

export type TraxCardProps = {
	title: string;
	children: ReactNode;
	readonly className?: string;
	readonly contentClassName?: string;
};

export const TraxCard = ({
	title,
	children,
	className,
	contentClassName,
}: TraxCardProps) => {
	return (
		<div className={clsx(styles.traxCard, className)}>
			<div className={styles.traxCardTitle}>{title}</div>
			<div className={clsx(styles.traxCardContent, contentClassName)}>
				{children}
			</div>
		</div>
	);
};
